import { Options, Vue } from 'vue-class-component';
import { NavStep, NavStepStatusID } from './nav-step';
import HelpScreen from '../help-screen/index.vue';
import HelpText from '../../assets/config/help-text.json';

@Options({
  props: {
    navSteps: Array,
    navbarText: String,
  },
  components: {
    HelpScreen
  }
})
export default class HeaderStepper extends Vue {
  private showHelpScreen = false;
  navSteps!: NavStep[]
  navbarText!: string;

  get pageHeader(): string {
    return HelpText[0].eoiApplication.pageHeading;
  }

  get pageDescription(): string {
    return HelpText[0].eoiApplication.pageDescription;
  }

  get pageSection(): any[] {
    return HelpText[0].eoiApplication.section;
  }

  private navigate(s: NavStep): void {
    const section: string = this.$route.query.sec as string;

    if (s.status === NavStepStatusID.Done && section !== 'confirmation') {
      const temp: string = JSON.stringify(this.$route.query);
      const tempJSON = JSON.parse(temp);
      tempJSON.sec = s.routeSecName;
      this.$router.push({ query: tempJSON });
    } 
  }

  private navigateBack() {
    const index = this.currentNavStepIndex();
    if (index > 0) {
      console.log(this.navSteps[index - 1].routeSecName);
      this.navigate(this.navSteps[index - 1]);
    }
  }

  private currentNavStepIndex(): number {
    let index = -1;
    this.navSteps.filter((z) => z.visible).forEach((x, i) => {
      if (x.status === NavStepStatusID.Current) {
        index = i;
      }
    });
    return index;
  }
  
}

